import { Position, HandleType as IHandleType } from 'reactflow';

export enum NodeVariant {
  PRIMARY = 'primaryNode',
  SECONDARY = 'secondaryNode',
}

export enum SecondaryNodeColor {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
}

export enum BorderStyle {
  SOLID = 'solid',
  DASHED = 'dashed',
}

export enum HandleType {
  SOURCE = 'source',
  TARGET = 'target',
}

export interface IPrimayNodeContainer {
  color?: string;
}

export interface ISecondaryNodeContainer {
  color: SecondaryNodeColor;
  borderStyle?: BorderStyle;
  selected?: boolean;
}

export interface INodeHandle {
  position: Position;
  type: IHandleType;
}
